export enum ControlType {
  ACCENT = 'accent',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

export type ControlTypeAccent = 'accent';
export type ControlTypePositive = 'positive';
export type ControlTypeNegative = 'negative';

export enum Priority {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
}

export type PriorityPrimary = 'primary';
export type PrioritySecondary = 'secondary';
export type PriorityTertiary = 'tertiary';
